import React from 'react';
import type { IconProps } from './IconPlus';

export const IconClose: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M5 5L15 15M5 15L15 5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
